module.exports = __webpack_public_path__ + "img/unodc_logo.203e9169.png";